// import {AsyncStorage} from 'react-native';
import * as ActionTypes from '../constants'; 
import axios from 'axios';
import {baseUrl} from './index';
import AsyncStorage from '@react-native-community/async-storage';

const dispatchRequestCurrentAffairs = currentAffairsData => ({
    type: ActionTypes.REQUEST_CURRENT_AFFAIRS,
    currentAffairsData
})


const dispatchReceivedCurrentAffairs = res => ({
    type: ActionTypes.RECEIVED_CURRENT_AFFAIRS,
    res
})

const dispatchErrorCurrentAffairs = (err) => ({
    type: ActionTypes.ERROR_CURRENT_AFFAIRS,
    err
})

export const dispatchClearCurrentAffairs = () => ({

    type: ActionTypes.CLEAR_CURRENT_AFFAIRS,
})



const dispatchRequestFullCurrentAffairs = fullDescriptionReqId => ({
    type: ActionTypes.REQUEST_FULL_CONTENT_DESCRIPTION,
    fullDescriptionReqId
})

const dispatchReceivedFullCurrentAffairs = res => ({
    type: ActionTypes.RECEIVED_FULL_CONTENT_DESCRIPTION,
    fullDescriptionResponse: res
})

const dispatchErrorFullCurrentAffairs = (fullDescriptionError) => ({
    type : ActionTypes.ERROR_FULL_CONTENT_DESCRIPTION,
    fullDescriptionError
})

export const dispatchClearFullCurrentAffairs = () => ({
    type: ActionTypes.CLEAR_FULL_CONTENT_DESCRIPTION
})


export function getCurrentAffairs({after, before}, isPagination) {   

    return dispatch => {        
        const endpoint = isPagination ? 'paginate_current_affairs' : 'current_affairs'
        const data =isPagination ? {
            afterId: after,
            beforeId: before
        } : null
        dispatch(dispatchRequestCurrentAffairs());
        
        AsyncStorage.getItem('authKey', (err, res) => {
            if(err) return  dispatch(dispatchErrorCurrentAffairs(err));
            if(res) {
                const authKey = res;
                const options = {
                    method: 'post',
                    url: `${baseUrl}/api/${endpoint}`,
                    headers:{
                        Authorization: `Bearer ${authKey}`
                    },
                    data,
                }
        
                axios(options)
                .then(({data}) =>{
                    dispatch(dispatchReceivedCurrentAffairs(data));
                })
                .catch(e => {
                    dispatch(dispatchErrorCurrentAffairs(e));
                })
            }
        })
       
       
    }

}

export const getFullContentCurrentAffairs = contentId  => dispatch => {       
            
            dispatch(dispatchRequestFullCurrentAffairs(contentId));

            AsyncStorage.getItem('authKey', (err,res) => {
                if(err) return dispatch(dispatchErrorFullCurrentAffairs(err));

                if(res){
                    const authKey = res;
                    const options ={
                        method:'post',
                        url : `${baseUrl}/api/current_affair/${contentId}`,
                        headers:{
                            Authorization: `Bearer ${authKey}` 
                        },
                        data: {
                            // id: contentId 
                        }
                    }

                    axios(options)
                    .then(({data}) =>{
                        dispatch(dispatchReceivedFullCurrentAffairs(data));
                    })
                    .catch(e => {
                        dispatch(dispatchErrorFullCurrentAffairs(e));
                    })
                }
            })
        
}
